import Vue from 'vue';
import Vuex from 'vuex';
import StorePlugins from '@/stores/plugins/StorePlugins';
import PredictedFlowModule from '@/stores/modules/PredictedFlowModule';
import IntegratorConfigModule from '@/stores/modules/IntegratorConfigModule';
import { API_BASE } from '../../config/api';

Vue.use(Vuex);

const vuexInstance = new Vuex.Store({
  plugins: StorePlugins,
  state: { API_BASE },
});

vuexInstance.registerModule('predicted_flow', PredictedFlowModule);
vuexInstance.registerModule('integrator_config', IntegratorConfigModule);

export default vuexInstance;
